/**
 * Store for template favorites functionality
 */
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { StoreModuleTypes } from '@/constants/store-constants';
import { TemplateFavoritesRepository, ToggleFavoriteRequest } from '@/communications/templates/repositories/template-favorites-repository';

export interface TemplateFavoritesState {
    isLoading: boolean;
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: StoreModuleTypes.TEMPLATE_FAVORITES
})
export class TemplateFavoritesStore extends VuexModule implements TemplateFavoritesState {
    readonly repository = new TemplateFavoritesRepository();
    isLoading = false;

    @Mutation
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    /**
     * Toggle a template's favorite status
     */
    @Action
    async toggleFavorite(request: ToggleFavoriteRequest): Promise<void> {
        this.setLoading(true);
        try {
            await this.repository.toggleFavorite(request);
        } finally {
            this.setLoading(false);
        }
    }

    /**
     * Get templates with favorites status included
     * This is primarily used by the template stores to enrich templates with favorite data
     */
    @Action
    async getTemplatesWithFavorites(type: 'emails' | 'texts') {
        return await this.repository.getTemplatesWithFavorites(type, true);
    }
}
